/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { Texture, BaseTexture, GraphicsGeometry } from 'pixi.js-legacy';

import { RendererCache } from '../ticket-renderer/RendererCache';
import { INSERTION_POINT_TEXTURES } from './InsertionPointConfiguration';

export class InsertionPointRenderer extends RendererCache {
	constructor(geometry?: GraphicsGeometry) {
		super(geometry);

		this.generateInsertionPointRectangleTexture();
	}

	protected generateInsertionPointRectangleTexture(): void {
		this._scratchContext.save();
		this._scratchContext.clearRect(0, 0, this._scratchCanvas.width, this._scratchCanvas.height);

		this._scratchCanvas.width = 4;
		this._scratchCanvas.height = 4;

		this._scratchContext.fillStyle = 'white';
		this._scratchContext.fillRect(0, 0, 4, 4);

		this.cacheTexture(
			INSERTION_POINT_TEXTURES.INSERTION_POINT_RECTANGLE,
			new Texture(new BaseTexture(this.getCanvasTexture()))
		);
	}
}
